import React from "react";
import InputLabel from "@mui/material/InputLabel";
import {loginFormInputLabelStyle} from "./LoginFormInputLabelStyle";

interface Props {
  text: string;
}

const LoginFormInputLabel: React.FC<Props> = ({text}) => {
  return (
    <InputLabel sx={loginFormInputLabelStyle.loginTextLebelMuiStyle}>
      {text}
    </InputLabel>
  );
};

export default LoginFormInputLabel;
